import { pickKeys } from '../utils';
export var fedopsLoggerProp = function (fedopsLogger) {
    return pickKeys(fedopsLogger, ['interactionEnded', 'interactionStarted']);
};
//# sourceMappingURL=fedopsLoggerProp.js.map